<template>
  <div class="builderinput" :class="props.customClass">
    <label
    :for="props.fieldName"
    v-html="props.fieldLabel"
    class="builderinput-label"
    ></label>
    <div class="builderinput-inputwrapper">
      <input
      type="text"
      inputmode="number"
      pattern="[0-9]*"
      :id="props.fieldName"
      ref="input"
      :name="props.fieldName"
      v-model="fieldValue"
      :max="maxValue"
      :min="minValue"
      @input="updateValue"
      @change="updateValue"
      @keydown="updateValue"
      @blur="touch"
      aria-required
      :aria-labelledby="`${props.fieldName} ${props.fieldName}Errors`"
      :aria-invalid="!isValid"
      autocomplete="off">
      <div class="builderinput-mimic"><span v-html="mimicFieldValue"></span></div>
      </div>
    <div
    :id="`${props.fieldName}Errors`"
    aria-live="polite"
    aria-relevant="additions removals">
      <div
      v-if="error"
      v-html="error"
      class="builderinput-error">

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps([
  'key',
  'fieldLabel',
  'fieldName',
  'fieldType',
  'displayType',
  'selected',
  'scope',
  'initValue',
  'min',
  'max',
  'required',
  'customClass',
  'initTouched',
  'initFocus',
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['updateValue'])

const input = ref(null);
const fieldValue = ref(props.initValue);
const error = ref('');
let isTouched = false;
let isGood = false;
let errorText = '';
let nonStandard = false;

const isValid = computed(() => {
  if (error.value.length) return false;
  return true;
})

const minValue = computed(() => {
  console.log(builder.quote.isCustom);
  if (builder.quote.isCustom) return 0;
  return props.min;
})

const maxValue = computed(() => {
  if (builder.quote.isCustom) return 100000;
  return props.max;
})

const mimicFieldValue = computed(() => {
  if (fieldValue.value) return fieldValue.value;
  return '.';
})

function updateValue() {

  emit('liveValue', props.fieldName, fieldValue.value);

  // format value
  let stringValue = fieldValue.value;
  let saveValue = fieldValue.value;
  if (props.fieldType == 'number') saveValue = parseFloat(saveValue);

  // if init touched
  if (typeof props.initTouched !== 'undefined' && props.initTouched) isTouched = true;

  // validate
  if (props.fieldType == 'number') {
    if (!isNaN(saveValue)) {
      if (saveValue > maxValue.value) {
        isGood = false;
        errorText = props.fieldName + ' must be less than ' + maxValue.value + 'mm';
        nonStandard = true;
      } else if (saveValue < minValue.value) {
        isGood = false;
        errorText = props.fieldName + ' must be more than ' + minValue.value + 'mm';
        nonStandard = true;
      } else if (isNaN(saveValue)) {
        isGood = false;
        errorText = props.fieldName + ' must be a valid number';
        nonStandard = false;
      } else {
        isGood = true;
        errorText = '';
        nonStandard = false;
      }
    } else if (saveValue.length) {
      errorText = '';
      if (saveValue >= minValue && saveValue <= maxValue) {
        isGood = true;
        nonStandard = false;
      }
    } else {
      isGood = false;
      errorText = isTouched ? 'This value is required' : '';
      nonStandard = false;
    }
  }

  if (isTouched) {
    error.value = errorText;
    emit('updateNonStandard', props.fieldName, nonStandard);
  }

  if (isGood) {
    emit('updateValue', props.fieldName, saveValue);
    if (isTouched) {
      builder.validateCurrentItem();
    }
  } else {
    emit('updateValue', props.fieldName, null);
  }


  if (builder.isTouched) builder.validateCurrentItem();
  // e.preventDefault();
  // return false;
}

function touch(e) {
  isTouched = true;
  updateValue();
}


onMounted(() => {

  let initFocus = true;
  if (typeof props.initFocus !== 'undefined') {
    initFocus = props.initFocus;
  }

  if (!builder.inputHasInitialFocus && initFocus) {
    input.value.focus();
    builder.inputHasInitialFocus = true;
  }

});

onBeforeUnmount(() => {

  builder.inputHasInitialFocus = false;

})


</script>
